<template>
  <div class="cockpit">

    <p v-if="loading">
      {{ $t('loading')}}...
    </p>

    <p v-else-if="error">
      <Error :message="error"/>
    </p>

    <div v-else>

      <NoData v-if='!hasData' />

      <CockpitSelector v-if='campaign_id' :campaigns='campaignsList' :loading='mapLoading' v-model='campaign_id' />

      <CockpitHeader v-if='campaign_id' :campaign='selectedCampaign' />

      <CockpitMap v-if='campaign_id' :campaign="selectedCampaign" @heatmap='mapLoading = false' />

    </div>

  </div>
</template>


<script>
import CockpitSelector from './CockpitSelector.vue'
import CockpitHeader from './CockpitHeader.vue'
import CockpitMap from './CockpitMap.vue'
import NoData from './NoData.vue'
import Error from './common/Error.vue'

import api from '../api'

export default {
  name: 'Cockpit',
  components: {
    CockpitSelector, CockpitHeader, CockpitMap, NoData, Error
  },
  data () {
    return {
      campaign_id: null,
      campaigns: [],
      loading: false,
      hasData: true,
      mapLoading: false,
      error: false,
      selectedCampaign: null
    }
  },
  created () {
    var self = this
    self.loading = true
    self.$Progress.set(25)
    self.buildMenu(1)
      .then(() => {
        self.$Progress.finish()
        self.loading = false
        self.campaign_id = self.campaigns.length ? self.campaigns[0].id : null
        self.hasData = self.campaigns.length > 0
      })
      .catch((e) => {
        self.$Progress.fail()
        self.loading = false
        self.error = e.response.data.error
      })
  },
  computed: {
    campaignsList () {
      return this.campaigns.map((c) => {
        return {
          id: c.id,
          name: c.name
        }
      })
    }
  },
  watch: {
    campaign_id () {
      var self = this
      this.mapLoading = true
      api.getCampaign(self.campaign_id)
        .then(r => {
          self.mapLoading = false

          self.selectedCampaign = r.data.data
        })
    }
  },
  methods: {
    loadingFinished () {
      this.loading = false
    },
    buildMenu (page) {
      var self = this

      return api.getCampaigns({ page })
        .then(r => {
          self.campaigns = self.campaigns.concat(r.data.data)
          if (r.data.links.next) {
            self.buildMenu(page + 1)
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Cockpit.vue